import { Button, Link } from "@mui/material";
import { BodyCopy, RacwaDetailedDialog } from "@racwa/react-components";
import { useStyles } from "./styles";

const FormotivMessageContent = () => {
  return (
    <BodyCopy gutterBottom>
      <strong>
        We&apos;ll cover your personal belongings up to $1500 if they're damaged, stolen or lost in a boat accident.
      </strong>
      <br />
      <br />
      <strong>
        Conditions, Limits and exclusions apply. Check{" "}
        <Link href={process.env.REACT_APP_PDS_PED_URL} rel="noreferrer noopener" target="_blank">
          PDS
        </Link>{" "}
        for details
      </strong>
    </BodyCopy>
  );
};

export interface FormotivDialogProps {
  open: boolean;
  onCloseFormotivDialog?: () => void;
}

export const FormotivDialog: React.FC<FormotivDialogProps> = ({ open, onCloseFormotivDialog }) => {
  const classes = useStyles;
  return open ? (
    <>
      <RacwaDetailedDialog
        open={open}
        onClickClose={onCloseFormotivDialog}
        title="Did you know?"
        titleId="formotiv-popup-dialog"
        maxWidth="xs"
        customChildren={[
          {
            dialogueContent: false,
            node: <FormotivMessageContent />,
          },
          {
            dialogueContent: false,
            node: (
              <Button
                id="btn-close"
                data-testid="btn-close"
                name="btn-close"
                sx={classes.button}
                onClick={onCloseFormotivDialog}
                color="primary"
              >
                Close
              </Button>
            ),
          },
        ]}
      />
    </>
  ) : null;
};

export default FormotivDialog;
